
import Computing from "../../../assets/duotone/Computing.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ComputingIcon({ className, dataTestid = "ComputingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Computing data-testid={dataTestid} className={classes} {...rest} />
  );
}
